import { render, staticRenderFns } from "./MgrupoenvasadoFormHeader.vue?vue&type=template&id=4d79731e"
import script from "./MgrupoenvasadoFormHeader.vue?vue&type=script&lang=js"
export * from "./MgrupoenvasadoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports